import type { ReactNode } from 'react';

/** Секция контактов в правой колонке: карточка представителя или предложение им стать (`.cf-bsc-detail-card`) */
export const BuildingContacts = ({ children }: { children: ReactNode }) => (
  <section data-name="BuildingContacts">{children}</section>
);
